import AddFromCurrentRecoveryPhraseIcon from './AddFromCurrentRecoveryPhraseIcon'

export default AddFromCurrentRecoveryPhraseIcon
